// This file generates a random code verifier for OAuth flows.
import { base64UrlEncode } from "./base64UrlEncode";
import { generateRandomCode } from "./generateRandomCode";

export async function generateCodeVerifier() {
  const random = await generateRandomCode();
  return base64UrlEncode(random);
}
